<template>
    <div>
        <button
            type="button"
            class="c-btn c-btn--white"
            :class="{ 'is-active': isOpen }"
            @click="handleToggle"
        >
            <span class="sc-text">
                {{ $t("Manufacturers.button") }}
            </span>
            <i class="ico ico-chevron-down" aria-hidden="true"></i>
        </button>

        <div class="c-manufacturers is-loading" v-if="isOpen">
            <div class="l-container l-container--wide">
                <div class="c-manufacturers__content">
                    <div class="c-manufacturers__filter">
                        <button
                            :class="{
                                'c-manufacturers__filter__item': true,
                                'is-active': activeTab === 'FAVORITE',
                            }"
                            @click="() => setActiveTab('FAVORITE')"
                        >
                            {{ $t("Manufacturers.favorite") }}
                        </button>
                        <div v-if="isCharactersLoading" class="c-manufacturers__filter__skeleton">
                            <div
                                v-for="index in 8"
                                class="c-manufacturers__filter__item is-skeleton"
                                :key="index + '-character'"
                            ></div>
                        </div>
                        <button
                            v-for="(character, index) in characters"
                            :class="{
                                'c-manufacturers__filter__item': true,
                                'is-active': activeTab === character,
                            }"
                            :key="index"
                            v-else
                            @click="() => setActiveTab(character)"
                        >
                            {{ character }}
                        </button>
                    </div>

                    <div class="c-manufacturers-list" v-if="isLoading">
                        <div
                            v-for="index in 12"
                            :key="index + '-item'"
                            class="c-manufacturers-list__item is-skeleton"
                        ></div>
                    </div>
                    <div class="c-manufacturers-list" v-else>
                        <a
                            v-for="(item, index) in items"
                            :href="item.link"
                            :key="index"
                            :title="item.name"
                            class="c-manufacturers-list__item"
                        >
                            <img
                                class="c-img"
                                :src="thumbnail(item.image, 'xs')"
                                :alt="item.name"
                            />
                        </a>
                    </div>
                    <a
                        href="/vyrobcovia"
                        class="c-manufacturers__more c-btn"
                        :title="$t('Manufacturers.completeList')"
                    >
                        {{ $t("Manufacturers.completeList") }}
                        <i class="ico ico-arrow-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { showHeaderOverlay, hideHeaderOverlay } from "./../../functions/overlay";
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";
import { checkResolution } from "../../functions/helpers";
import { thumbnail } from "Functions/thumbnail";

const lang = document.querySelector("html").getAttribute("lang");
let locale;

import(`../../locale/${lang}`).then((module) => {
    locale = module.Swal;
});

export default {
    data() {
        return {
            isOpen: false,
            items: [],
            activeTab: "FAVORITE",
            characters: [],
            fetchCancelToken: null,
            isInitialized: false,
            fetchingItems: true,
            fetchingCharacters: true,
        };
    },
    computed: {
        isLoading() {
            return this.fetchingItems;
        },
        isCharactersLoading() {
            return this.fetchingCharacters;
        },
    },
    created() {
        this.fetchItems("FAVORITE");
    },
    methods: {
        cancelFetchItems() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel();
            }

            this.fetchCancelToken = CancelToken.source();
        },
        cancelFetchCharacters() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel();
            }

            this.fetchCancelToken = CancelToken.source();
        },
        fetchItems(value) {
            this.cancelFetchItems();
            this.items = [];
            this.fetchingItems = true;

            client
                .get(`/get-manufacturers?filter=${value}`, {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.items = Object.values(response.data.data);
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingItems = false;
                });
        },
        fetchCharacters() {
            this.characters = [];
            this.fetchingCharacters = true;

            client
                .get("/get-manufacturer-characters", {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.characters = Object.values(response.data.data);
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingCharacters = false;
                });
        },
        handleClickOutside($event) {
            if (
                this.isOpen &&
                !this.$el.contains($event.target) &&
                !$event.target.closest(".swal2-container") &&
                !$event.target.closest(".notify")
            ) {
                this.handleToggle(false);
            }
        },
        handleToggle(event) {
            if (!checkResolution("cxs;xs")) {
                if (event) {
                    event.preventDefault();
                }
                this.toggleMenu();
            }
        },
        thumbnail(image, format) {
            return thumbnail(image, format);
        },
        toggleMenu(bool) {
            if (typeof bool !== "boolean") {
                bool = !this.isOpen;
            }

            this.isOpen = bool;

            if (bool) {
                document.addEventListener("click", this.handleClickOutside);
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        setActiveTab(value) {
            this.activeTab = value;
        },
    },
    watch: {
        isOpen(value) {
            if (value) {
                showHeaderOverlay("manufacturers");
                document.querySelector(".js-page-header").classList.add("is-manufacturers-open");
                if (!this.characters.length) {
                    this.fetchCharacters();
                }
            } else {
                hideHeaderOverlay("manufacturers");
                document.querySelector(".js-page-header").classList.remove("is-manufacturers-open");
            }
        },
        activeTab(value) {
            this.fetchItems(value);
        },
    },
};
</script>
